import { render, staticRenderFns } from "./CheckedPosts.vue?vue&type=template&id=84f0865a&scoped=true&"
import script from "./CheckedPosts.vue?vue&type=script&lang=js&"
export * from "./CheckedPosts.vue?vue&type=script&lang=js&"
import style0 from "./CheckedPosts.vue?vue&type=style&index=0&id=84f0865a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f0865a",
  null
  
)

export default component.exports